import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=56815215&scoped=true&"
import script from "./UserOverview.vue?vue&type=script&lang=js&"
export * from "./UserOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserOverview.vue?vue&type=style&index=0&id=56815215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56815215",
  null
  
)

export default component.exports